/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
// components

import IndexDropdown from "components/Dropdowns/IndexDropdown.js";

export default function Navbar(props) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  const handleReload = () => {
    // Redirect to the root URL and reload the whole page
    window.location.href = "/";
  };
  return (
    <>
      <nav className="top-0 z-50 w-full flex flex-wrap items-center justify-between px-2 py-1 mb-4 navbar-expand-lg bg-white shadow">
        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
          {/* Logo Section */}
          <div className="flex items-center">
            <Link  className="text-blueGray-700 text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase" onClick={handleReload}>
              <img
                src={require("assets/img/essentials_small.png")}
                alt="Logo not found"
                style={{ width: '200px' }}
              />
            </Link>
          </div>

          {/* Navbar Toggle Button */}
          {/* <button
            className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
            type="button"
            onClick={() => setNavbarOpen(!navbarOpen)}
          >
            <i className="fas fa-bars"></i>
          </button> */}
          
        </div>
      </nav>
    </>
  );
}
